export default {
  page: {
    home: "Accueil",
    search: "Recherche",
    skills: "Les Compétences",
    skills_stats: "Statistiques",
    skills_synthesis: "Synthèse par alternant",
    dashboard: "Tableau de bord",
    questionnaires: "Les questionnaires",
    weblinks: "Vos liens utiles",
    gradebook: "Vos bulletins de notes",
    attestations: "Vos attestations de présence",
    message: "Messagerie",
    document: "Vos documents partagés",
    document_add: "Ajouter un document",
    document_add_note: "Ajouter une note",
    lessons: "Vos cours",
    timetable: "Votre emploi du temps",
    absence: "Gestion de l'assiduité",
    profile: "Profil",
    questionnaire: "Questionnaire",
    training_list: "Liste des formations",
    institution_list: "Liste des établissements",
    institution_dashboard: "Tableau de bord de l'établissement",
    registration_dashboard: "Tableau de bord des inscriptions",
    training_dashboard: "Tableau de bord de la formation",
    pre_registration: "Fiche de pré-inscription",
    pre_registration_edit: "Configuration de la fiche de pré-inscription",
    step_edit: "Configuration des étapes",
    contract: "Contrat",
    training_course_list: "Liste des promotions",
    driver_licence_config: "Gestion des aides permis B",
    driver_licence_list: "Liste des demandes d'aide au permis B",
    driver_licence: "Aide au permis B",
    login: "Connexion",
    notepad: "Bloc-notes",
    new_message: "Nouveau message",
    new_password: "Nouveau mot de passe",
    reset_password: "Réinitialiser son mot de passe",
    error: "Erreur",
    switch: "Connexion",
    maintenance: "Maintenance",
    platformNotFount: "Plateforme non configurée",
    download: {
      title: "Téléchargement de fichier",
      processing: "Téléchargement en cours...",
      success: "Fichier téléchargé avec succès !",
    },
    registration_list: "Liste des fiches de pré-inscription",
  },
};
